(function () {
  var ROOT_SELECTOR = '#adjustable-flex-deal-addon';
  var GROUP_SELECTOR = '.adjustable-flex-deal-addon__variant-group';
  var CARD_SELECTOR = '.adjustable-flex-deal-addon__product-card';
  var VARIANT_ITEM_SELECTOR = '.adjustable-flex-deal-addon__variant-item';
  var FIRMNESS_BTN_SELECTOR = '.adjustable-flex-deal-addon__firmness-btn';
  var RADIO_SELECTOR = '.adjustable-flex-deal-addon__radio';
  var MAIN_SIZE_DROPDOWN_SELECTOR = '#dropdownMattressSize';

  function getDatasetValue(element, key) {
    if (!element) return '';
    return element.getAttribute('data-' + key) || '';
  }

  function parseVariantLabel(label) {
    if (!label) return '';

    var cleaned = label.replace(/\s*-\s*SOLD OUT\s*$/i, '').trim();
    if (!cleaned) return '';

    var separator = cleaned.indexOf(' / ') !== -1 ? ' / ' : '/';
    return cleaned.split(separator)[0].trim();
  }

  function getMainProductSize() {
    var dropdown = document.querySelector(MAIN_SIZE_DROPDOWN_SELECTOR);
    if (!dropdown || dropdown.selectedIndex < 0) return '';

    var selected = dropdown.options[dropdown.selectedIndex];
    if (!selected) return '';

    var variantLabel =
      selected.getAttribute('data-variant') ||
      selected.getAttribute('data-title') ||
      selected.textContent;

    return parseVariantLabel(variantLabel);
  }

  function shouldSyncMainSize(root) {
    return getDatasetValue(root, 'sync-main-size') === 'true';
  }

  function findVariant(group, firmness, size) {
    var items = group.querySelectorAll(VARIANT_ITEM_SELECTOR);
    var matchedAvailable = null;
    var matchedAny = null;

    items.forEach(function (item) {
      var itemFirmness = getDatasetValue(item, 'variant-firmness');
      var itemSize = getDatasetValue(item, 'variant-size');
      var isAvailable = getDatasetValue(item, 'variant-available') === 'true';

      if (firmness && itemFirmness !== firmness) return;
      if (size && itemSize !== size) return;

      matchedAny = item;
      if (isAvailable) matchedAvailable = item;
    });

    return matchedAvailable || matchedAny;
  }

  function updateGroupRadio(group, variantId) {
    var radio = group.querySelector(RADIO_SELECTOR);
    if (!radio) return;

    radio.setAttribute('data-variant-id', variantId);
  }

  function getRadioVariantId(radio) {
    return getDatasetValue(radio, 'variant-id');
  }

  function ensureDefaultRadioSelection(root) {
    var radios = root.querySelectorAll(RADIO_SELECTOR);
    if (!radios.length) return;

    var targetRadio =
      root.querySelector(RADIO_SELECTOR + '[data-default-selection="true"]') || radios[0];

    radios.forEach(function (radio) {
      radio.checked = radio === targetRadio;
    });

    updateSelectedAddonState(root);
  }

  function updateSelectedAddonState(root) {
    var checkedRadio = root.querySelector(RADIO_SELECTOR + ':checked');

    root.querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var groupRadio = group.querySelector(RADIO_SELECTOR);
      var isSelected = !!(checkedRadio && groupRadio === checkedRadio);
      group.classList.toggle('is-addon-selected', isSelected);
    });

    if (checkedRadio) {
      root.setAttribute('data-selected-addon-variant-id', getRadioVariantId(checkedRadio));
    } else {
      root.removeAttribute('data-selected-addon-variant-id');
    }
  }

  function selectAddonRadio(root, radio) {
    if (!radio) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindAddonRadios(root) {
    var radios = root.querySelectorAll(RADIO_SELECTOR);
    if (!radios.length) return;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateSelectedAddonState(root);
      });
    });

    root.querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var radio = group.querySelector(RADIO_SELECTOR);
      var card = group.querySelector(CARD_SELECTOR);

      if (!radio || !card) return;

      card.addEventListener('click', function () {
        selectAddonRadio(root, radio);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectAddonRadio(root, radio);
        }
      });
    });
  }

  function updatePrice(card, variantItem) {
    var priceWrap = card.querySelector('.adjustable-flex-deal-addon__product-card-price');
    if (!priceWrap) return;

    var isAvailable = getDatasetValue(variantItem, 'variant-available') === 'true';
    var priceFormatted = getDatasetValue(variantItem, 'variant-price-formatted');
    var compareFormatted = getDatasetValue(variantItem, 'variant-compare-price-formatted');

    if (!isAvailable) {
      priceWrap.innerHTML = '<span class="adjustable-flex-deal-addon__price-soldout">SOLD OUT</span>';
      return;
    }

    var priceHtml = '<span class="adjustable-flex-deal-addon__price-current">' + priceFormatted + '</span>';

    if (compareFormatted) {
      priceHtml +=
        '<span class="adjustable-flex-deal-addon__price-compare">' + compareFormatted + '</span>';
    }

    priceWrap.innerHTML = priceHtml;
  }

  function updateCard(group, variantItem) {
    var card = group.querySelector(CARD_SELECTOR);
    if (!card || !variantItem) return;

    var variantId = getDatasetValue(variantItem, 'variant-id');
    var variantTitle = getDatasetValue(variantItem, 'variant-title');
    var variantImage = getDatasetValue(variantItem, 'variant-image');
    var image = card.querySelector('.adjustable-flex-deal-addon__product-card-image');
    var variantLabel = card.querySelector('.adjustable-flex-deal-addon__product-card-variant');

    card.setAttribute('data-selected-variant-id', variantId);

    if (image && variantImage) {
      image.setAttribute('data-src', variantImage);
      image.setAttribute('src', variantImage);
    }

    if (variantLabel) {
      variantLabel.textContent = variantTitle;
    }

    updatePrice(card, variantItem);

    updateGroupRadio(group, variantId);

    group.querySelectorAll(VARIANT_ITEM_SELECTOR).forEach(function (item) {
      item.classList.toggle('is-selected', item === variantItem);
    });
  }

  function applySelection(root, firmness, size) {
    root.querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var matchedVariant = findVariant(group, firmness, size);

      if (matchedVariant) {
        updateCard(group, matchedVariant);
      }
    });

    if (firmness) {
      root.setAttribute('data-selected-firmness', firmness);
    }

    if (size) {
      root.setAttribute('data-selected-size', size);
    }

    updateSelectedAddonState(root);
  }

  function applyFirmness(root, firmness) {
    var size = getDatasetValue(root, 'selected-size') || getMainProductSize();
    applySelection(root, firmness, size);
  }

  function applySize(root, size) {
    var firmness = getSelectedFirmness(root);
    applySelection(root, firmness, size);
  }

  function setActiveFirmnessButton(root, firmness) {
    root.querySelectorAll(FIRMNESS_BTN_SELECTOR).forEach(function (button) {
      button.classList.toggle('is-active', getDatasetValue(button, 'firmness') === firmness);
    });
  }

  function getSelectedFirmness(root) {
    var activeButton = root.querySelector(FIRMNESS_BTN_SELECTOR + '.is-active');
    if (activeButton) {
      return getDatasetValue(activeButton, 'firmness');
    }

    return getDatasetValue(root, 'default-firmness') || 'Medium';
  }

  function bindMainSizeListener(root) {
    if (!shouldSyncMainSize(root)) return;

    var dropdown = document.querySelector(MAIN_SIZE_DROPDOWN_SELECTOR);
    if (!dropdown || dropdown.dataset.addonSizeBound === 'true') return;

    dropdown.dataset.addonSizeBound = 'true';

    dropdown.addEventListener('change', function () {
      var size = getMainProductSize();
      if (size) {
        applySize(root, size);
      }
    });
  }

  function isValidVariantId(id) {
    return !!(id && /^\d+$/.test(String(id).trim()));
  }

  function createLineItem(variantId) {
    var lineItem = {
      quantity: 1,
      id: String(variantId).trim(),
      properties: {}
    };

    if (window.RC && RC.cart && typeof RC.cart.generateUniqueLineItemId === 'function') {
      lineItem.properties._line_item_uid = RC.cart.generateUniqueLineItemId();
    }

    return lineItem;
  }

  function getSelectedAddonVariantId(root) {
    if (!root) return '';

    var checkedRadio = root.querySelector(RADIO_SELECTOR + ':checked');
    if (checkedRadio) {
      return getRadioVariantId(checkedRadio);
    }

    return root.getAttribute('data-selected-addon-variant-id') || '';
  }

  function isAdjustableBedDealPage(root) {
    return getDatasetValue(root, 'main-product-handle') === 'adjustable-bed-deal';
  }

  function collectFreeGiftItems() {
    var items = [];
    var sharedTimestamp = new Date().toISOString();
    var container = document.querySelector('#free-product-container');
    var firstAttr = container ? (container.getAttribute('data-first-free-gift-attribute') || '').trim() : '';
    var secondAttr = container ? (container.getAttribute('data-second-free-gift-attribute') || '').trim() : '';

    document.querySelectorAll('.free-gift-product-block').forEach(function (block, idx) {
      var checked = block.querySelector('input.free-gift-radio-input:checked');
      if (!checked || !checked.value) return;

      var item = createLineItem(checked.value);
      item.properties['_Free Gift'] = 'Yes';
      item.properties['_timestamp'] = sharedTimestamp;

      if (idx === 0 && firstAttr) {
        item.properties[firstAttr] = 'Yes';
      }
      if (idx === 1 && secondAttr) {
        item.properties[secondAttr] = 'Yes';
      }

      items.push(item);
    });

    return items;
  }

  function buildDealCartItems(root) {
    var dropdown = document.querySelector(MAIN_SIZE_DROPDOWN_SELECTOR);
    if (!dropdown || !isValidVariantId(dropdown.value)) {
      return null;
    }

    var items = [];
    var addonVariantId = getSelectedAddonVariantId(root);
    var freeGiftItems = isAdjustableBedDealPage(root) ? collectFreeGiftItems() : [];

    if (isValidVariantId(addonVariantId)) {
      var addonItem = createLineItem(addonVariantId);

      if (freeGiftItems.length > 0) {
        addonItem.properties['_Has Free Gift'] = 'Yes';
        addonItem.properties['_timestamp'] = freeGiftItems[0].properties['_timestamp'];
      }

      items.push(addonItem);
      freeGiftItems.forEach(function (freeGiftItem) {
        items.push(freeGiftItem);
      });
    } else if (freeGiftItems.length > 0) {
      freeGiftItems.forEach(function (freeGiftItem) {
        items.push(freeGiftItem);
      });
    }

    var mainItem = createLineItem(dropdown.value);

    if (freeGiftItems.length > 0 && !isValidVariantId(addonVariantId)) {
      mainItem.properties['_timestamp'] = freeGiftItems[0].properties['_timestamp'];
      mainItem.properties['_Has Free Gift'] = 'Yes';
    }

    items.push(mainItem);
    return items;
  }

  function finishAddToCart(button, isOpenCart) {
    if (!window.RC || !RC.cart || typeof RC.cart.get !== 'function') {
      window.location.href = '/cart';
      return;
    }

    RC.cart.get(function (response) {
      if (window.ajaxifyShopify) {
        ajaxifyShopify.updateCountPrice(response);
        if (isOpenCart) {
          ajaxifyShopify.buildCart(response);
          return;
        }
      }

      window.location.href = '/cart';
    });
  }

  function addItemsToCart(items, onSuccess, onFail) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }),
      contentType: 'application/json',
      dataType: 'json',
      cache: false
    })
      .done(onSuccess)
      .fail(onFail);
  }

  function handleAddToCart(button) {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || !shouldSyncMainSize(root)) {
      return false;
    }

    var items = buildDealCartItems(root);
    if (!items || !items.length) {
      return false;
    }

    var $button = window.jQuery ? jQuery(button) : null;
    var isOpenCart = button.getAttribute('data-open-cart') === 'true';

    if ($button) {
      $button.addClass('loading');
    }

    addItemsToCart(
      items,
      function () {
        if ($button) {
          $button.removeClass('loading');
        }
        finishAddToCart(button, isOpenCart);
      },
      function () {
        if ($button) {
          $button.removeClass('loading');
        }
      }
    );

    return true;
  }

  function initAdjustableFlexDealAddon() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.dataset.firmnessInitialized === 'true') return;

    root.dataset.firmnessInitialized = 'true';

    var defaultFirmness = getSelectedFirmness(root);
    var mainSize = shouldSyncMainSize(root) ? getMainProductSize() : '';

    root.querySelectorAll(FIRMNESS_BTN_SELECTOR).forEach(function (button) {
      button.addEventListener('click', function () {
        var firmness = getDatasetValue(button, 'firmness');
        setActiveFirmnessButton(root, firmness);
        applyFirmness(root, firmness);
      });
    });

    setActiveFirmnessButton(root, defaultFirmness);
    bindAddonRadios(root);
    applySelection(root, defaultFirmness, mainSize || undefined);
    ensureDefaultRadioSelection(root);
    bindMainSizeListener(root);

    if (shouldSyncMainSize(root)) {
      window.addEventListener('load', function () {
        var sizeOnLoad = getMainProductSize();
        if (sizeOnLoad) {
          applySize(root, sizeOnLoad);
        }
        ensureDefaultRadioSelection(root);
      });
    }
  }

  window.AdjustableFlexDealAddon = {
    handleAddToCart: handleAddToCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdjustableFlexDealAddon);
  } else {
    initAdjustableFlexDealAddon();
  }
})();
